import { useState } from "react";
import "./faq.css";

const faqData = [
  {
    icon: "far fa-building",
    question: "What types of properties can I buy in Abu Dhabi?",
    answer:
      "You can buy apartments, villas, townhouses, penthouses, plots, and commercial properties across Abu Dhabi's designated investment zones.",
  },
  {
    icon: "fas fa-chart-line",
    question: "Is Abu Dhabi a good place for real estate investment?",
    answer:
      "Yes. Abu Dhabi offers a stable property market, attractive rental yields, strong infrastructure, and a growing selection of freehold communities.",
  },
  {
    icon: "far fa-user",
    question: "How does NV Real Estate help buyers?",
    answer:
      "Our specialists shortlist suitable properties, arrange viewings, support negotiations, and guide buyers through every step of the purchase.",
  },
  {
    icon: "fas fa-home",
    question: "Can you help find rental properties?",
    answer:
      "Yes. We help tenants find residential and commercial rental properties that suit their location, lifestyle, and budget.",
  },
  {
    icon: "far fa-file-alt",
    question: "What are the payment options available?",
    answer:
      "Payment options vary by property and may include cash purchases, mortgages, developer payment plans, and post-handover plans.",
  },
  {
    icon: "fas fa-map-marker-alt",
    question: "Which areas in Abu Dhabi are best for investment?",
    answer:
      "Popular investment areas include Yas Island, Saadiyat Island, Al Reem Island, Al Raha Beach, and Masdar City.",
  },
];

const trustItems = [
  {
    icon: "fas fa-shield-alt",
    title: "RERA Certified Advisors",
    text: "Trusted & Regulated",
  },
  {
    icon: "fas fa-award",
    title: "10+ Years Experience",
    text: "In Abu Dhabi Real Estate",
  },
  {
    icon: "far fa-building",
    title: "500+ Properties Available",
    text: "Buy, Sell & Rent",
  },
  {
    icon: "fas fa-headset",
    title: "Free Consultation",
    text: "No Obligation",
  },
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const sectionBackground = {
    backgroundImage:
      'radial-gradient(circle at 50% 15%, rgba(210, 224, 255, 0.48), transparent 34%), linear-gradient(180deg, rgba(247, 250, 255, 0.94) 0%, rgba(255, 255, 255, 0.88) 48%, rgba(241, 246, 255, 0.91) 100%), url("/assets/images/abu.jpg")',
  };

  const toggleItem = (index) => {
    setActiveIndex((current) => (current === index ? null : index));
  };

  return (
    <section className="nv-faq-section" style={sectionBackground}>
      <div className="nv-faq-container">
        <header className="nv-faq-heading"> 
          <h2>Frequently Asked Questions</h2>
          <p>
            Find answers to common questions about buying, selling,
            <br className="nv-faq-desktop-break" /> and investing in Abu Dhabi real estate.
          </p>
        </header>

        <div className="nv-faq-main">
          <aside className="nv-faq-advisor">
            <div className="nv-faq-advisor-copy">
              <h3>Need Expert Property Advice?</h3>
              <span className="nv-faq-gold-line" />
              <p>
                Our real estate specialists are here to help you find the perfect
                property or investment opportunity in Abu Dhabi.
              </p>
            </div>

            <div className="nv-faq-profile">
              <div className="nv-faq-profile-photo">
                <img src="/images/faq-agent.png" alt="NV Real Estate property consultant" />
              </div>
              <div className="nv-faq-profile-details">
                <strong>Dalaa Tayar</strong>
                <span>Property Consultant</span>
                <small><i className="fas fa-shield-alt" /> 10+ Years Experience</small>
                <a className="nv-faq-call-button" href="tel:+971501577822">
                  <i className="fas fa-phone-alt" /> Call Now
                </a>
                <a
                  className="nv-faq-whatsapp-button"
                  href="https://wa.me/971501577822"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-whatsapp" /> WhatsApp Us
                </a>
              </div>
            </div>

            <div className="nv-faq-contact">
              <span><i className="fas fa-phone-alt" /></span>
              <div>
                <a href="tel:+971501577822">+971 50 157 7822</a>
                <a href="mailto:info@nvrealestate.ae">info@nvrealestate.ae</a>
              </div>
            </div>
          </aside>

          <div className="nv-faq-accordion">
            {faqData.map((item, index) => {
              const isActive = activeIndex === index;
              return (
                <article className={`nv-faq-item${isActive ? " active" : ""}`} key={item.question}>
                  <button
                    className="nv-faq-question"
                    type="button"
                    onClick={() => toggleItem(index)}
                    aria-expanded={isActive}
                    aria-controls={`nv-faq-answer-${index}`}
                  >
                    <span className="nv-faq-question-icon"><i className={item.icon} /></span>
                    <strong>{item.question}</strong>
                    <span className="nv-faq-toggle" aria-hidden="true" />
                  </button>
                  <div
                    className="nv-faq-answer"
                    id={`nv-faq-answer-${index}`}
                    aria-hidden={!isActive}
                  >
                    <p>{item.answer}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>

        <div className="nv-faq-trust-strip">
          {trustItems.map((item) => (
            <div className="nv-faq-trust-item" key={item.title}>
              <i className={item.icon} />
              <div>
                <strong>{item.title}</strong>
                <span>{item.text}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
